/**
 * Real-time Synced Conversations Log Dataset
 */
export const n8nConversations = [
  {
    id: 'chat-101',
    customerName: 'Somchai K.',
    platform: 'LINE OA',
    channelColor: '#00B900',
    avatar: 'SK',
    phone: '081-998-2234',
    lastMessage: 'Request official proposal for Commercial Office Space (250 sqm)',
    lastMessageTime: '01:14 PM',
    status: 'Synced',
    aiIntent: 'High Leasing Intent',
    aiScore: 92,
    messages: [
      { id: 1, sender: 'user', text: 'Hello, interested in leasing commercial office space at Royal Phuket Marina.', time: '01:10 PM' },
      { id: 2, sender: 'bot', text: 'Hello! Welcome to Royal Phuket Marina. What type of property or office space are you looking for?', time: '01:11 PM' },
      { id: 3, sender: 'user', text: 'Request official proposal for 250 sqm office space with sea view. Urgent move-in. Tel: 081-998-2234', time: '01:14 PM' },
      { id: 4, sender: 'bot', text: 'Thank you! Your inquiry has been processed and assigned to our leasing team. We will email your formal proposal within 15 minutes.', time: '01:15 PM' }
    ]
  },
  {
    id: 'chat-102',
    customerName: 'Khun Anan',
    platform: 'Facebook Messenger',
    channelColor: '#1877F2',
    avatar: 'KA',
    phone: '089-445-1123',
    lastMessage: 'Looking for Luxury Waterfront Villa Investment 2 Units',
    lastMessageTime: '12:45 PM',
    status: 'Synced',
    aiIntent: 'Qualified Investor',
    aiScore: 88,
    messages: [
      { id: 1, sender: 'user', text: 'Hi, I saw your Facebook Ad for Royal Phuket Marina Luxury Waterfront Villa.', time: '12:40 PM' },
      { id: 2, sender: 'bot', text: 'Hello Khun Anan! Thank you for contacting Royal Phuket Marina. Are you looking for personal residence or rental investment property?', time: '12:42 PM' },
      { id: 3, sender: 'user', text: 'Looking for Luxury Waterfront Villa Investment 2 Units, budget around 15M THB.', time: '12:45 PM' },
      { id: 4, sender: 'bot', text: 'Great! Your inquiry has been qualified and synced to our CRM. Our senior sales agent will send the master plan brochure shortly.', time: '12:46 PM' }
    ]
  }
];
